export default __webpack_public_path__ + "static/media/workcafe-dashboard.8b332f7e.JPG";